export default __webpack_public_path__ + "static/media/POSTULACION_CRDC PREMIOS IMPULSO SUMe.a34d5f42.pdf";